// A brown bear, modelled facing +X: a massive rounded body, stout legs, a broad
// head with round ears. Ported 1:1 from age-of-mcp's classic bear.ts, restoring
// its original leg loop + body/head/snout/ear composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.07, 0.04], [0.07, -0.04], [-0.07, 0.04], [-0.07, -0.04]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.014, 0.013, 0.1, 5),
      color: "#4a3320", position: [x!, 0.05, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.075, 0), color: "#5e4127",
      position: [0, 0.1, 0], scale: [1.7, 1.1, 1.05] },               // body
    { geometry: new THREE.IcosahedronGeometry(0.045, 0), color: "#684932",
      position: [0.11, 0.11, 0], scale: [1.1, 1, 1] },                // head
    { geometry: new THREE.ConeGeometry(0.02, 0.04, 5), color: "#503a26",
      position: [0.15, 0.105, 0], rotation: [0, 0, -Math.PI / 2] },    // snout
    { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#4a3320",
      position: [0.1, 0.148, 0.028] },                                // round ear
    { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#4a3320",
      position: [0.1, 0.148, -0.028] },
  );
  return parts;
}

export const bear = defineModel({
  id: "bear",
  scale: 2.3, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Bear",
  tags: ["creature","bear","low-poly","age-of-mcp","classic"],
  summary: "Low-poly bear.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.18,
  parts: () => partsFor(),
  animations: [],
});
